<template>
    <section class="card-recharge-view">
        <HeaderComponent :title="'Recarregar Cartão'" />

        <div class="card-rech-container">
            <div class="button-cont" @click="confirmValues">
                <ButtonCenter :button="confirmValuesButton" />
            </div>
            <br>

            <div class="totalValue">
                <h1>Valor Total</h1>
                <h1 v-text="formatValue(totalValue)"></h1>
            </div>

            <div class="list-fields">
                <div v-for="(field, key) in fields" :key="key" class="list-field">
                    <h1 v-text="field"></h1>
                </div>
            </div>

            <div v-if="loading" class="loading">
                <i class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
            </div>
            <div v-else-if="sons.length > 0" class='dependents' v-for="(son, fkey) in sons" :key="fkey">
                <div class="dep-name">
                    <i class="fa fa-user fa-lg fa-regular icon"></i>
                    <h1>{{ son.NMCONSUMIDOR }}</h1>
                </div>
                <div class="list">
                    <div class="list-item" v-for="(school, ekey) in son.schools" :key="ekey" @click="selectSchool(school)">
                        <div class="list-item-field">
                            <h1 v-text="school.school"></h1>
                        </div>
                        <div class="list-item-field">
                            <h1 v-text="formatValue(school.value)"></h1>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="not-found">
                <h1>Não há cartões para recarregar.</h1>
            </div>

        </div>

        <RechargeValueComponent ref="rechargeValueComponent" :storeName="selectedSchool.school" @updateValue="updateValue" :initialRechargeValue="selectedSchool.value" :resetAfterConfirm="true"/>
        <PaymentMethodModal />
    </section>
</template>

<script>
import HeaderComponent from '@/components/header/HeaderComponent.vue'
import ButtonCenter from '@/components/buttons/center/ButtonCenter.vue'
import RechargeValueComponent from '@/components/bottom-popups/RechargeValueComponent.vue'
import PaymentMethodModal from '@/components/modals/PaymentMethodModal.vue'
import { showAlertNotification } from '@/libs/Util.js'
import { getCardRechargeDetails } from '@/components/controllers/CardRechargeController.js'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'CardRechargeView',
    components: {
        HeaderComponent,
        ButtonCenter,
        RechargeValueComponent,
        PaymentMethodModal
    },
    data () {
        return {
            fields: ['Escola', 'Valor'],
            confirmValuesButton: {
                display: 'Confirmar Valores',
                fill: false,
                action: this.confirmValues
            },
            sons: [],
            selectedSchool: {},
            totalValue: 0,
            loading: false
        }
    },
    methods: {
        confirmValues: function () {
            if (this.totalValue <= 0) {
                showAlertNotification({
                    title: '',
                    text: 'O valor total das recargas deve ser maior que R$ 0,00.'
                })
                return
            }
            const rechargeValues = {
                sonsValues: [],
                totalValue: 0
            }
            this.sons.forEach(son => {
                son.schools.forEach(school => {
                    if (school.value > 0) {
                        rechargeValues.sonsValues.push({
                            CDCONSUMIDOR: son.CDCONSUMIDOR,
                            CDFAMILISALD: school.CDFAMILISALD,
                            NMCONSUMIDOR: son.NMCONSUMIDOR,
                            VRSALDCONFAM: school.value
                        })
                    }
                })
            })
            rechargeValues.totalValue = this.totalValue
            this.setRechargeValues(rechargeValues)

            this.storeSons(this.sons)
            this.showPayMethodModal({ type: 'default', text: 'Escolha uma forma de pagamento:' })
        },
        selectSchool: function (school) {
            this.selectedSchool = school
            this.changeCardRechargeMenuVisibility()
        },
        updateValue (value) {
            if (value === 0) {
                this.selectedSchool.value = 0
            } else {
                this.selectedSchool.value = value || this.selectedSchool.value
            }
            this.updateTotalValue()
            this.changeCardRechargeMenuVisibility()
        },
        formatValue (value) {
            return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        },
        updateTotalValue () {
            let total = 0
            this.sons.forEach(son => {
                son.schools.forEach(school => {
                    total += school.value
                })
            })
            this.totalValue = total
        },
        ...mapActions(['changeCardRechargeMenuVisibility', 'showPayMethodModal', 'closePayMethodModal', 'setRechargeValues', 'storeSons'])
    },
    computed: {
        ...mapGetters(['storedSons'])
    },
    mounted () {
        this.closePayMethodModal()
        this.loading = true

        if (this.storedSons?.length > 0) {
            this.sons = this.storedSons
            this.updateTotalValue()
            this.loading = false
            return
        }

        getCardRechargeDetails().then(res => {
            this.loading = false
            if (res.error) {
                showAlertNotification({
                    title: '',
                    text: res.message
                })

                this.$router.push({ path: '/profile', replace: true })
            } else {
                // filtrar a resposta que junta filhos e escolas
                // filhos têm o campo NMCONSUMIDOR preenchido e as escolas não
                const sonsValues = res.filter(function (son) {
                    return son.NMCONSUMIDOR != null
                })

                sonsValues.forEach(son => {
                    son.schools = []
                    res.forEach(school => {
                        if (school.NMCONSUMIDOR == null && school.PARENT === son.CDCONSUMIDOR) {
                            son.schools.push({
                                school: school.NMFAMILISALD,
                                value: parseFloat(school.VRSALDCONFAM.replace(',', '.')),
                                CDFAMILISALD: school.CDFAMILISALD
                            })
                        }
                    })
                })

                this.sons = sonsValues
                this.updateTotalValue()
            }
        })
    }
}
</script>

<style lang="less" scoped>
.card-rech-container {
    position: relative;
    height: calc(100vh - 76px);
    overflow-y: auto;

    &::-webkit-scrollbar {
        display: none;
    }

    .button-cont {
        position: absolute;
        right: 0;

        button {
            width: 100%;
            padding: 5px;
            margin: 0;
        }
    }

    .totalValue {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        h1 {
            font-weight: 600;
        }
    }

    .list-fields {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        margin-bottom: 20px;
        h1 {
            font-weight: 600;
        }
    }

    .dependents {
        margin-bottom: 30px;
        .dep-name {
            display: flex;
            flex-direction: row;
            align-items: baseline;

            h1 {
                padding-left: 10px;
                font-weight: 600;
            }
        }

        .list-item {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            padding: 20px 10px;
            border: 1px solid var(--cardBorder);
            box-shadow: 2px 2px 4px var(--cardBorder);
            border-radius: 5px;

            .list-item-field {
                max-width: 60%;
            }
        }
    }

    .not-found, .loading {
        display: flex;
        justify-content: center;
        h1 {
            font-weight: 600;
        }
    }
}
</style>
